module.exports = __webpack_public_path__ + "static/img/PL.8e1bf24b.svg";